// TUT-551 — a ficha da pessoa da equipe, no contrato da API
// (`docs/product/plano-tut-551-ficha-da-equipe.md`, "Contrato HTTP para a
// web"; o modelo da API é `apps/api/src/domain/models/ficha-da-equipe.ts`).
import type { GrupoResumido } from "./membros-e-acesso";

export const TIPOS_DE_REGISTRO_PROFISSIONAL = ["OAB", "CREA", "CRM", "CRQ", "CFT", "OUTRO"] as const;
export type TipoDeRegistroProfissional = (typeof TIPOS_DE_REGISTRO_PROFISSIONAL)[number];

export interface RegistroProfissional {
  kind: TipoDeRegistroProfissional;
  number: string;
  /** A sigla da UF. */
  state: string;
}

/** A foto sem os bytes. */
export interface FotoDaFicha {
  width: number;
  height: number;
  sizeBytes: number;
  sha256: string;
  updatedAt: string;
}

/** O que a ficha guarda e o PATCH escreve (nome e e-mail ficam na conta). */
export interface CamposDaFichaDaEquipe {
  /** O nome de tratamento: como a pessoa aparece no app. */
  preferredName: string | null;
  /** Cargo ou função. */
  jobTitle: string | null;
  /** Só os dígitos, com o DDD (a máscara é da tela). */
  mobilePhone: string | null;
  phone: string | null;
  professionalRegistry: RegistroProfissional | null;
  /** `AAAA-MM-DD`, sem fuso. */
  joinedOn: string | null;
}

/** A ficha como `GET /users/:membershipId/ficha` e `GET /auth/profile/ficha` a devolvem. */
export interface FichaDaEquipe extends CamposDaFichaDaEquipe {
  membershipId: string;
  userId: string;
  name: string;
  email: string;
  active: boolean;
  groups: GrupoResumido[];
  /** A pessoa tem vínculo com outro escritório: nome e e-mail só mudam por ela. */
  inOtherOffices: boolean;
  photo: FotoDaFicha | null;
  /** Já com o `?v=<sha256>` (foto nova é URL nova); `null` sem foto. */
  photoUrl: string | null;
  updatedAt: string | null;
}

/**
 * O corpo do PATCH (`UpdateFichaDaEquipe`): parcial. Campo ausente não muda;
 * `null` apaga. O registro vai inteiro ou `null`.
 */
export type EntradaDaFichaDaEquipe = {
  preferredName?: string | null;
  jobTitle?: string | null;
  mobilePhone?: string | null;
  phone?: string | null;
  professionalRegistry?: { kind: string; number: string; state: string } | null;
  joinedOn?: string | null;
};

/** O resumo de cada linha de `GET /users` (`profile`); `null` para o externo. */
export interface ResumoDaFichaDaEquipe {
  preferredName: string | null;
  jobTitle: string | null;
  hasPhoto: boolean;
  photoVersion: string | null;
  photoUrl: string | null;
}

/**
 * TUT-558 — `GET /equipe/fotos`: a foto de cada pessoa da equipe interna
 * ativa que tem foto (a URL já com o `?v=`), para os avatares de toda a
 * equipe. O portal não tem esta lista (decisão do dono em 29/10).
 */
export interface FotosDaEquipe {
  items: Array<{ userId: string; photoUrl: string }>;
}
